import React, {useEffect, useState} from "react";
import {useSelector} from 'react-redux'
import Wrapper from "components/blocks/Wrapper";
import Container from "components/blocks/Container";
import DefaultLayout from "layouts/Default";
import cn from "clsx";
import Link from "next/link";
import {useRouter} from "next/router";
import MyBreadcrumbs from "components/MyBreadcrumbs";
import Typography from '@mui/material/Typography';
import useWindowDimensions from '../../../utils/WindowDimensions'
import BrandCard from "components/cards/BrandCard";
import MySlider from "components/MySlider";
import {getPaginatedBrandsThunk} from "lib/features/brandSlice";
import {useDispatch} from "react-redux";
import {wrapper} from "lib/store";
import {getPaginatedLocationsThunk} from "lib/features/mapSlice";
import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import {useTranslation} from "next-i18next";
import config from '../../../data/config.json'
import {checkMobile} from "../../../utils/helper";

const BRANDS_ROUTE = config.brand.route

const BREAD_ROUTE = [
    {label: 'Home', href: '/', isActive: false},
    {label: 'Brands', href: '/brands/discovery', isActive: true},
]

export const getServerSideProps = wrapper.getServerSideProps(store => async (context) => {
    const {
        query,locale,
    } = context
    return {
        props: {
            ...(await serverSideTranslations(locale, ['home', 'common']))
        }
    }
})

export default function Discovery(props) {
    const router = useRouter()
    const dispatch = useDispatch()
    const { height, width } = useWindowDimensions();
    let brands = useSelector(state => state.brand.brands)
    let featuredBrands = brands.slice(0,12)
    let productBrands = brands.filter(item => item.bizType === 'PRODUCT')
    let serviceBrands = brands.filter(item => item.bizType === 'SERVICE')
    let otherBrands = brands.filter(item => item.bizType === 'OTHERS')
    let storeBrands = brands.filter(item => item.bizType === 'LOCATION')
    const [loaded, setLoaded] = useState(false)
    const { t } = useTranslation()

    async function initBrand() {
        const sort = {}
        const page = 1
        const filter = {}
        await dispatch(getPaginatedBrandsThunk({page, filter, sort}))
    }
    useEffect(() => {
        if (brands[0].name === 'Test') {
            initBrand()
        } else {
            setLoaded(true)
        }
        return () => {
            console.log('clean up initBrand')
        }
    }, [brands])

    const [isMobile, setIsMobile] = useState(false)

    useEffect(() => {
        if (loaded) {
            setIsMobile(checkMobile())
        }
    }, [loaded])

    return (
        <>
            <Wrapper>
                <div style={{ width: '100%', borderBottom: 'solid thin #DDDDDD' }}>
                    <Container>
                        <MyBreadcrumbs  routeList={BREAD_ROUTE} t={t} />
                        {
                            isMobile ?
                                null :
                                <h1 style={{ letterSpacing: 3, marginTop: 30, marginBottom: 40, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 36 }}>
                                    {t('home:brandBanner1')}  <Typography sx={{ marginLeft: 2, fontWeight: 400, textTransform: 'none', fontSize: 30 }}>{t('home:footer_slogan')}</Typography>
                                </h1>
                        }
                        <nav className={isMobile ? cn('flex', 'grow', 'shrink', 'min-w-0', 'overflow-scroll', 'mt-10') : cn('flex', 'grow', 'shrink', 'min-w-0', 'overflow-hidden')}>
                            {
                                BRANDS_ROUTE.map(route => {
                                    return (
                                        <Link href={route.href} key={route.label}>
                                            <a style={{ fontSize: 14, fontWeight: router.pathname === route.href ? 600 : 400,
                                                borderBottom: router.pathname === route.href ? 'solid 2px #108085' : 'unset'
                                            }}  className={
                                                isMobile ?
                                                    cn(
                                                        'font-normal', 'mr-7', 'last:mr-0', 'leading-5',
                                                    ) :
                                                    cn(
                                                        'font-normal', 'mr-7', 'last:mr-0', 'leading-10',
                                                    )
                                            }>
                                                {t(`home:${route.label}`)}
                                            </a>
                                        </Link>
                                    )
                                })

                            }
                        </nav>
                    </Container>
                </div>
                {
                    loaded ?
                        featuredBrands[0].name === 'Test' ?
                            <Container style={{ marginTop: 50 }}>
                                <span>{t('home:pleaseRefresh')}</span>
                            </Container> :
                        <>
                            <Container style={{ marginTop: 50 }}>
                                <MySlider t={t} style={{ marginBottom: 20 }} itemComponent={BrandCard} dataList={featuredBrands} title={t('home:brands_featured_brands')} subTitle={t('home:sponsored')} showAll={false} href={'/brands'} showArrows={true}  />

                                <MySlider t={t} style={{ marginBottom: 20 }} itemComponent={BrandCard} href={'/brands/products'} dataList={productBrands} title={t('home:brands_product_brands')} showAll={true} showArrows={true} />

                                <MySlider t={t} style={{ marginBottom: 20 }} itemComponent={BrandCard} href={'/brands/services'} dataList={serviceBrands} title={t('home:brands_service_brands')} showAll={true} showArrows={true}  />

                                <MySlider t={t} style={{ marginBottom: 20 }} itemComponent={BrandCard} href={'/brands/stores'} dataList={storeBrands} title={t('home:brands_store_clinic_brands')} showAll={true} showArrows={true} />

                                <MySlider t={t} style={{ marginBottom: 20 }} itemComponent={BrandCard} href={'/brands/others'} dataList={otherBrands} title={t('home:brands_other_brands')} showAll={true} />

                            </Container>
                        </> :
                        <Container style={{ marginTop: 50 }}>
                            <span>{t('home:loading')}</span>
                        </Container>
                }
            </Wrapper>

        </>
    )
}

Discovery.getLayout = function getLayout(page) {
    return (
        <DefaultLayout>
            {page}
        </DefaultLayout>
    )
}


